<template>
    <footer class="footer footer-transparent d-print-none">
        <div class="container-xl">
            <div class="row text-center align-items-center flex-row-reverse">
                <div class="col-lg-auto ms-lg-auto">
                    <ul class="list-inline list-inline-dots mb-0">
                        <li class="list-inline-item">
                            <strong>Desarrollado por <router-link to="/staff" style="cursor:pointer;">CGR/DGTIC/DST/DDS</router-link> | <a  style="color: #285289;" href="https://www.contraloria.gov.py" target="_blank">Contraloría General de la República</a></strong>
                        </li>
                    </ul>
                </div>
                <div class="col-12 col-lg-auto mt-3 mt-lg-0">
                    <ul class="list-inline list-inline-dots mb-0">
                        <li class="list-inline-item">
                            <strong>Portal de Datos Abiertos </strong> &copy; 2023
                        </li>
                        <li class="list-inline-item">
                            Versión 1.0
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'TabFooter'
}
</script>